import { baseFetch } from 'src/utils';

export const rejectCartAPI = async (
  cartId: string,
  rejectNotes: string,
  layer: number,
) => {
  const res = await baseFetch(`/api/org/cart-approvals/${cartId}/reject`, {
    method: 'POST',
    body: JSON.stringify({ rejectNotes, layer }),
  });

  if (!res.ok) {
    throw new Error('Failed to reject cart');
  }

  return true;
};
